module.exports = __webpack_public_path__ + "img/service6.7f32f75f.png";